import {
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  OnInit,
  ViewChild
} from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

import { FileUploadService } from '../../service/disbursment/file-upload.service';
import { ToastrService } from 'ngx-toastr';
import { DisbursmentService } from '../../service/disbursment/disbursment.service';

import { saveAs } from 'file-saver';

import { FileDisplayComponent } from '../file-display/file-display.component';
import { ClientService } from '../../service/disbursment/client.service';
import { DisbursmentDetails } from 'src/app/modules/Disbursment_modules/disbursment/disbursment.component.model';
import { DisbursementService } from '../../service/disbursment/disbursement.component.service';
import { DisbursDtlsCompComponent } from 'src/app/modules/Disbursment_modules/disbursment/disburs-dtls-comp/disburs-dtls-comp.component';


/* =====================================================
   FILE MODEL
===================================================== */

export interface FileUploadData {
  file_id?: number;
  name: string;
  description: string;
  file_path: string;
  complete_file_path: string;
  presigned_url: string;
  sync?: string;
  type?: string;
  size?: string;
  source_type?: string;
}

export interface DisputeStep {
  title: string;
  index: number;
  selected: boolean;
  titleInput: string;
  reasonInput: string;
}

/* =====================================================
   TIMELINE MODELS
===================================================== */

export interface TimelineAttachment
  extends FileUploadData {
}

export interface StepComment {
  author?: string;
  role?: string;
  comment: string;
  step_name?: string;
  step_index?: number;
  date_time?: string;
}
export interface TimelineItem {
  status: string;
  date: string;
  time: string;
  updatedBy: string;
  remarks: string;
  comment?: string;
  completed: boolean;
  current: boolean;
  attachments: TimelineAttachment[];
  title: string;
  comments: StepComment[];
  portagent_pda_amount?: number;
  actual_pda_amount?: number;
  portagent_fda_amount?: number;
  actual_fda_amount?: number;
}


/* =====================================================
   COMPONENT
===================================================== */

@Component({

  selector: 'app-floating-file-viewer',

  templateUrl: './floating-file-viewer.component.html',

  styleUrls: ['./floating-file-viewer.component.scss']

})
export class FloatingFileViewerComponent
  implements OnInit {


  /* =====================================================
     INPUTS
  ===================================================== */

  @Input()
  disbursementSeq!: number;


  @Input()
  disbursementId!: string;


  /* =====================================================
     OUTPUT
  ===================================================== */

  @Output()
  close = new EventEmitter<void>();


  /* =====================================================
     SERVICES
  ===================================================== */
disputeSteps: DisputeStep[] = [];
  private loader = inject(DisbursmentService);

expenseData: any[] = [];
expenseColumns: string[] = [];

expenseType: 'PDA' | 'FDA' | null = null;

showAllExpenses = false;
isExpenseLoading = false;
  constructor(

    private fileUploadService: FileUploadService,

    private snackBar: ToastrService,

    private sanitizer: DomSanitizer,

    private dialog: MatDialog,
    private clientService: ClientService,
    private disbursementService: DisbursementService,

  ) {}


  /* =====================================================
     VARIABLES
  ===================================================== */

  timeline: TimelineItem[] = [];

  previewFiles: FileUploadData[] = [];

  isLoading = false;

  isTimelineLoading = false;

showDisputeForm = false;
disputeReason = '';
isDisputeSubmitting = false;
  /* =====================================================
     INIT
  ===================================================== */

  ngOnInit(): void {

    if (!this.disbursementSeq) {

      this.snackBar.error(
        'Invalid disbursement sequence.'
      );

      return;

    }

    this.loadTimeline();

  }


  /* =====================================================
     LOAD TIMELINE
     
     IMPORTANT:
     disbursementSeq is directly used here.
  ===================================================== */

loadTimeline(): void {
  this.isTimelineLoading = true;
  this.loader.show();

  this.clientService
    .getDisbursementTimeline(this.disbursementSeq)
    .subscribe({
      next: (response: any) => {

        const timelineSteps =
          response?.timeline_steps ||
          response?.data?.timeline_steps ||
          response?.timeline ||
          response?.data?.timeline ||
          (Array.isArray(response) ? response : []);

        this.timeline = this.mapTimeline(timelineSteps).reverse();

        // Load PDA / FDA expense details
        this.loadDisbursementExpenseDetails(timelineSteps);

        this.isTimelineLoading = false;
        this.loader.hide();
      },

      error: (error) => {
        this.isTimelineLoading = false;
        this.loader.hide();

        this.snackBar.error(
          error?.error?.error || 'Error fetching timeline.'
        );
      }
    });
}

loadDisbursementExpenseDetails(timelineSteps: any[]): void {

  const pdaApproved = timelineSteps.some(
    (step: any) =>
      step?.title?.toLowerCase() === 'pda approved' &&
      step?.status?.toUpperCase() === 'COMPLETED'
  );

  const fdaApproved = timelineSteps.some(
    (step: any) =>
      step?.title?.toLowerCase() === 'fda approved' &&
      step?.status?.toUpperCase() === 'COMPLETED'
  );

  // If neither PDA nor FDA is completed,
  // don't show expense table.
  if (!pdaApproved && !fdaApproved) {
    this.expenseData = [];
    this.expenseType = null;
    return;
  }

  this.isExpenseLoading = true;

  this.disbursementService
    .getDisbursementDataDtls(this.disbursementSeq)
    .subscribe({
      next: (details: any) => {

        const disbursementDetails =
          new DisbursmentDetails(details);

        /*
         * FDA has priority if FDA is approved.
         * Otherwise show PDA.
         */
        if (
          fdaApproved &&
          disbursementDetails.fda_expenses?.length
        ) {

          this.expenseType = 'FDA';

          this.expenseData =
            disbursementDetails.fda_expenses || [];

        } else if (
          pdaApproved &&
          disbursementDetails.pda_expenses?.length
        ) {

          this.expenseType = 'PDA';

          this.expenseData =
            disbursementDetails.pda_expenses || [];

        } else {

          this.expenseData = [];
          this.expenseType = null;
        }

        // Create table columns from the expense data
        if (this.expenseData.length > 0) {
          this.expenseColumns = Object.keys(
            this.expenseData[0]
          );
        } else {
          this.expenseColumns = [];
        }

        this.isExpenseLoading = false;
        this.isTimelineLoading = false;
        this.loader.hide();
      },

      error: (error) => {

        this.expenseData = [];
        this.expenseColumns = [];
        this.expenseType = null;

        this.isExpenseLoading = false;
        this.isTimelineLoading = false;
        this.loader.hide();

        console.error(
          'Error loading disbursement expense details:',
          error
        );
      }
    });
}

private mapTimeline(steps: any[]): TimelineItem[] {
  return (steps || []).map((step: any) => {

    const dateValue =
      step.date_time ||
      step.updated_on ||
      step.timestamp ||
      step.date ||
      '';

    const title =
      step.title ||
      step.name ||
      step.status_name ||
      step.status ||
      '';

    const isClientComment =
      this.normalizeStatus(title) === 'CLIENT COMMENT';

    // Map documents array
    const attachments: TimelineAttachment[] = (step.documents || []).map((doc: any) => ({
      file_id: doc.file_id,
      name: doc.document_name,
      description: step.description || title,
      file_path: doc.complete_file_path,
      complete_file_path: doc.complete_file_path,
      presigned_url: doc.document_url,
      sync: doc.sync,
      source_type: doc.source_type
    }));

    // Map comments array
    const comments: StepComment[] = (step.comments || []).map((cmt: any) => ({
      author: cmt.author || 'Client',
      role: cmt.role || 'Client',
      comment: cmt.comment || '',
      step_name: cmt.step_name || title,
      step_index: cmt.step_index,
      date_time: cmt.date_time ? this.formatDateTime(cmt.date_time) : ''
    }));

    return {
      status: title,
      title: title,
      date: dateValue ? this.formatDateTime(dateValue) : '',
      time: dateValue ? this.formatTime(dateValue) : '',
      updatedBy: step.updated_by || step.updatedBy || step.user || '',
      remarks: !isClientComment ? (step.remarks || step.remark || '') : '',
      comment: isClientComment ? (step.description || '') : '',
      completed: step.status === 'COMPLETED' || step.completed === true,
      current: step.status === 'CURRENT' || step.current === true,
      attachments: attachments,
      comments: comments,

      // Map amounts
      portagent_pda_amount: step.portagent_pda_amount != null ? Number(step.portagent_pda_amount) : undefined,
      actual_pda_amount: step.actual_pda_amount != null ? Number(step.actual_pda_amount) : undefined,
      portagent_fda_amount: step.portagent_fda_amount != null ? Number(step.portagent_fda_amount) : undefined,
      actual_fda_amount: step.actual_fda_amount != null ? Number(step.actual_fda_amount) : undefined
    };
  });
}


Math = Math;

  /* =====================================================
     LOAD FILES
     
     SAME disbursementSeq
  ===================================================== */

  loadFiles(): void {

    const data = {

      disbursement_seq:
        this.disbursementSeq,

      pda_fda_flag:
        'DIS'

    };


    this.isLoading = true;


    this.fileUploadService
      .fileDataFromDb(data)
      .subscribe({

        next: (res: FileUploadData[]) => {

          console.log(
            'Files response:',
            res
          );


          this.previewFiles =
            res || [];


          /*
           * Match files with their
           * corresponding timeline status.
           */

          this.assignFilesToTimeline(
            this.previewFiles
          );


          this.isLoading = false;

          this.isTimelineLoading = false;

          this.loader.hide();

        },


        error: (error) => {

          console.error(
            'Error fetching files:',
            error
          );


          this.isLoading = false;

          this.isTimelineLoading = false;

          this.loader.hide();


          this.snackBar.error(

            error?.error?.error ||
            'Error fetching files.'

          );

        }

      });

  }


  

  /* =====================================================
     GET STATUS FROM FILE
     
     PDA- -> PDA
     FDA- -> FDA
  ===================================================== */

private getFileStatus(file: FileUploadData): string {
  const path = (
    file.complete_file_path ||
    file.file_path ||
    file.name ||
    ''
  ).toUpperCase();

  if (path.includes('PDA')) return 'PDA';
  if (path.includes('FDA')) return 'FDA';

  return '';
}

private assignFilesToTimeline(files: FileUploadData[]): void {
  if (!this.timeline.length) {
    return;
  }

  // Clear existing attachments
  this.timeline.forEach(item => {
    item.attachments = [];
  });

  (files || []).forEach(file => {

    // API returns the timeline step in `description`
    const fileStep = this.normalizeStatus(
      file.description || ''
    );

    if (!fileStep) {
      return;
    }

    const matchingStep = this.timeline.find(item => {

      const timelineStep = this.normalizeStatus(
        item.title || item.status || ''
      );

      return timelineStep === fileStep;
    });

    if (matchingStep) {
      matchingStep.attachments.push(file);
    }
  });
}

  /* =====================================================
     NORMALIZE STATUS
  ===================================================== */

  private normalizeStatus(
    value: string
  ): string {

    return (value || '')

      .toUpperCase()

      .replace(/[_-]/g, ' ')

      .replace(/\s+/g, ' ')

      .trim();

  }


  /* =====================================================
     CLOSE
  ===================================================== */

  closeOverlay(): void {

    this.close.emit();

  }


  /* =====================================================
     PREVIEW CHECK
  ===================================================== */

  canPreview(
    file: FileUploadData
  ): boolean {

    const url =
      file?.presigned_url || '';


    const lower =
      url.toLowerCase();


    return (

      lower.includes('.pdf') ||

      lower.includes('.png') ||

      lower.includes('.jpg') ||

      lower.includes('.jpeg')

    );

  }


  /* =====================================================
     VIEW FILE
  ===================================================== */

  viewFile(
    file: FileUploadData
  ): void {

    if (!this.canPreview(file)) {

      this.snackBar.error(
        'Cannot preview this file.'
      );

      return;

    }


    if (!file.presigned_url) {

      this.snackBar.error(
        'Preview link is not available.'
      );

      return;

    }


    this.previewWithRetry(
      file,
      file.presigned_url
    );

  }


  /* =====================================================
     PREVIEW WITH RETRY
  ===================================================== */

  private previewWithRetry(

    file: FileUploadData,

    presignedUrl: string

  ): void {

    fetch(
      presignedUrl,
      {
        method: 'GET'
      }
    )

      .then(
        response => {

          /*
           * Expired presigned URL
           */

          if (
            response.status === 403
          ) {

            this.refreshPresignedUrlAndPreview(
              file
            );

            return;

          }


          if (
            response.status === 404
          ) {

            this.snackBar.error(
              'File not found.'
            );

            return;

          }


          if (response.ok) {

            this.openPreviewDialog(
              presignedUrl,
              file.name
            );

            return;

          }


          throw new Error(
            `HTTP ${response.status}`
          );

        }
      )

      .catch(
        () =>
          this.snackBar.error(
            'Cannot preview this file.'
          )
      );

  }


  /* =====================================================
     REFRESH PREVIEW URL
  ===================================================== */

  private refreshPresignedUrlAndPreview(
    file: FileUploadData
  ): void {

    const data = {

      disbursement_seq:
        this.disbursementSeq,

      pda_fda_flag:
        'DIS'

    };


    this.fileUploadService
      .fileDataFromDb(data)
      .subscribe({

        next: (res) => {

          const updatedFile =
            res.find(
              (f: FileUploadData) =>
                f.file_id === file.file_id
            );


          if (
            updatedFile?.presigned_url
          ) {

            this.openPreviewDialog(

              updatedFile.presigned_url,

              file.name

            );

          } else {

            this.snackBar.error(
              'Unable to refresh preview link.'
            );

          }

        },

        error: () =>
          this.snackBar.error(
            'Error refreshing preview link.'
          )

      });

  }


  /* =====================================================
     OPEN PREVIEW DIALOG
  ===================================================== */

  private openPreviewDialog(

    url: string,

    fileName: string

  ): void {

    const previewUrl =
      this.sanitizer
        .bypassSecurityTrustResourceUrl(
          url
        );


    this.dialog.open(
      FileDisplayComponent,
      {

        data: {

          url: previewUrl,

          name: fileName

        },

        width: '100vw',

        height: '100vh',

        maxHeight: '100vh',

        maxWidth: '100vw'

      }
    );

  }


  /* =====================================================
     DOWNLOAD
  ===================================================== */

  downloadFile(
    file: FileUploadData
  ): void {

    this.downloadWithRetry(
      file,
      file.presigned_url
    );

  }


  /* =====================================================
     DOWNLOAD WITH RETRY
  ===================================================== */

  private downloadWithRetry(

    file: FileUploadData,

    presignedUrl: string

  ): void {

    if (!presignedUrl) {

      this.snackBar.error(
        'Error while downloading the file.'
      );

      return;

    }


    fetch(presignedUrl)

      .then(
        response => {

          if (
            response.status === 403
          ) {

            this.refreshPresignedUrlAndDownload(
              file
            );

            return;

          }


          if (
            response.status === 404
          ) {

            this.snackBar.error(
              'File not found.'
            );

            return;

          }


          if (!response.ok) {

            throw new Error(
              `HTTP ${response.status}`
            );

          }


          return response.blob();

        }
      )

      .then(
        blob => {

          if (blob) {

            saveAs(
              blob,
              file.name
            );

          }

        }
      )

      .catch(
        () =>
          this.snackBar.error(
            'Error while downloading the file.'
          )
      );

  }


  /* =====================================================
     REFRESH DOWNLOAD URL
  ===================================================== */

  private refreshPresignedUrlAndDownload(
    file: FileUploadData
  ): void {

    const data = {

      disbursement_seq:
        this.disbursementSeq,

      pda_fda_flag:
        'DIS'

    };


    this.fileUploadService
      .fileDataFromDb(data)
      .subscribe({

        next: (res) => {

          const updatedFile =
            res.find(
              (f: FileUploadData) =>
                f.file_id === file.file_id
            );


          if (
            updatedFile?.presigned_url
          ) {

            this.downloadWithRetry(

              file,

              updatedFile.presigned_url

            );

          } else {

            this.snackBar.error(
              'Unable to refresh download link.'
            );

          }

        },

        error: () =>
          this.snackBar.error(
            'Error refreshing download link.'
          )

      });

  }


  /* =====================================================
     FILE ICON
  ===================================================== */

  getFileIcon(
    fileName: string
  ): string {

    const lower =
      (fileName || '').toLowerCase();


    if (
      lower.endsWith('.pdf')
    ) {

      return 'picture_as_pdf';

    }


    if (

      lower.endsWith('.jpg') ||

      lower.endsWith('.jpeg') ||

      lower.endsWith('.png') ||

      lower.endsWith('.gif')

    ) {

      return 'image';

    }


    if (

      lower.endsWith('.xls') ||

      lower.endsWith('.xlsx') ||

      lower.endsWith('.csv')

    ) {

      return 'grid_on';

    }


    if (

      lower.endsWith('.doc') ||

      lower.endsWith('.docx')

    ) {

      return 'description';

    }


    return 'insert_drive_file';

  }


  /* =====================================================
     STATUS CLASS
  ===================================================== */

  getStatusClass(
    item: TimelineItem
  ): string {

    if (item.status === 'Rejected') {

      return 'badge-rejected';

    }


    if (item.completed) {

      return 'badge-completed';

    }


    if (item.current) {

      return 'badge-current';

    }


    return 'badge-pending';

  }


  /* =====================================================
     STATUS TEXT
  ===================================================== */

getStatusText(item: TimelineItem): string {
  if (item.status === 'Rejected') {
    return 'Rejected';
  }

  if (item.completed) {
    return 'Completed';
  }

  if (item.current) {
    return 'In Progress';
  }

  return 'Pending';
}


  /* =====================================================
     DATE FORMAT
  ===================================================== */

formatDateTime(date: string): string {
  if (!date) {
    return '';
  }

  const parsedDate = new Date(
    date.endsWith('Z') ? date : date + 'Z'
  );

  if (isNaN(parsedDate.getTime())) {
    return '';
  }

  return (
    parsedDate.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC'
    }) +
    ' ' +
    parsedDate.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
      timeZone: 'UTC'
    }) +
    ' UTC'
  );
}
formatTime(date: string): string {
  if (!date) {
    return '';
  }

  // API date is in UTC
  const parsedDate = new Date(
    date.endsWith('Z') ? date : date + 'Z'
  );

  if (isNaN(parsedDate.getTime())) {
    return '';
  }

  return (
    parsedDate.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
      timeZone: 'UTC'
    }) + ' UTC'
  );
}
// Add state variable inside FloatingFileViewerComponent
isUploading = false;

/* =====================================================
   UPLOAD FILE FOR STEP
===================================================== */
onFileSelected(event: Event, item: TimelineItem): void {
  const input = event.target as HTMLInputElement;

  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];

  const stepTitle = (item.title || item.status || '').toUpperCase();

  this.isUploading = true;
  this.loader.show();

  this.fileUploadService
    .uploadTimelineDocument(
      this.disbursementSeq.toString(),
      stepTitle,
      file.name,
      file
    )
    .subscribe({
      next: () => {
        this.snackBar.success('File uploaded successfully!');

        this.isUploading = false;
        this.loader.hide();

        input.value = '';

        this.loadFiles();
      },

      error: (error) => {
        this.isUploading = false;
        this.loader.hide();

        input.value = '';

        this.snackBar.error(
          error?.error?.message || 'Failed to upload file.'
        );
      }
    });
}
formatExpenseColumn(column: string): string {
  return column
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
}
toggleExpenseView(): void {
  this.showAllExpenses = !this.showAllExpenses;
}

isDisputeFormValid(): boolean {
  const selectedSteps = this.getSelectedDisputeSteps();
  if (selectedSteps.length === 0) return false;

  return selectedSteps.every(
    step => step.reasonInput?.trim().length > 0
  );
}

toggleStepSelection(step: DisputeStep): void {
  step.selected = !step.selected;
  if (!step.selected) {
    step.reasonInput = '';
  }
}
closeDisputeForm(): void {
  if (this.isDisputeSubmitting) {
    return;
  }

  this.showDisputeForm = false;
  this.disputeReason = '';
}
getSelectedDisputeSteps(): DisputeStep[] {
  return this.disputeSteps.filter(step => step.selected);
}
openDisputeForm(): void {
  this.showDisputeForm = true;
  this.initializeDisputeSteps();
}
initializeDisputeSteps(): void {
  this.disputeSteps = this.timeline.map((item, index) => ({
    title: item.title,
    index: this.timeline.length - index,
    selected: false,
    titleInput: '',
    reasonInput: ''
  }));
}
raiseDispute(): void {
  if (!this.isDisputeFormValid()) {
    this.snackBar.error('Please fill in dispute remarks for all selected steps.');
    return;
  }

  const selectedDisputes = this.getSelectedDisputeSteps().map(step => ({
    step_name: step.title,
    step_index: step.index,
    comment: step.reasonInput.trim()
  }));

  const payload = {
    disbursement_id: String(this.disbursementId),
    disbursement_seq: this.disbursementSeq,
    disputes: selectedDisputes
  };

  this.isDisputeSubmitting = true;

  this.disbursementService.raiseDispute(payload).subscribe({
    next: () => {
      this.isDisputeSubmitting = false;
      this.snackBar.success('Dispute raised successfully.');
      this.closeDisputeForm();
      this.loadTimeline();
    },
    error: (error: any) => {
      this.isDisputeSubmitting = false;
      this.snackBar.error(
        error?.error?.detail ||
        error?.error?.message ||
        'Failed to raise dispute.'
      );
    }
  });
}
// Add this getter in floating-file-viewer.component.ts
get totalAgentAmount(): number {
  return this.expenseData.reduce((sum, item) => {
    const val = parseFloat(item['Agent Amount'] || item['agent_amount'] || 0);
    return sum + (isNaN(val) ? 0 : val);
  }, 0);
}

// Add state variable inside FloatingFileViewerComponent
downloadingReportStep: string | null = null;

downloadReport(option: 'PDA' | 'FDA', item: TimelineItem): void {
  const data = {
    disbursement_seq: this.disbursementSeq,
    report_type: option
  };

  // Track active downloading step
  this.downloadingReportStep = item.title;

  this.fileUploadService.downloadReport(data, this.disbursementId).subscribe({
    next: (res: any) => {
      this.downloadingReportStep = null;
      this.snackBar.success(`${option} report downloaded successfully.`);
      
    },
    error: (error: any) => {
      this.downloadingReportStep = null;
      const errMsg = error?.error?.message || error?.message || "Something went wrong, please try again later.";
      this.snackBar.error(errMsg);
    }
  });
}

isPaymentInstructionAllowed(): boolean {
    if (!this.disbursementObj) {
      return false;
    }
     const username = sessionStorage.getItem('username') || '';
      if (username !== 'Meraki - Operations') {
    return false;
  }


    const pdaStatus = (this.disbursementObj.pda_status || '').toLowerCase();
    const fdaStatus = (this.disbursementObj.fda_status || '').toLowerCase();

    return pdaStatus === 'completed' || fdaStatus === 'completed';
  }

@Input() disbursementObj!: any;
@ViewChild('disbursDtlsComp') disbursDtlsComp!: DisbursDtlsCompComponent;
openPaymentInstruction(): void {
    if (this.disbursDtlsComp) {
      this.disbursDtlsComp.openPaymentInstructionEmailDialog();
    } else {
      this.snackBar.error('Payment instruction is currently unavailable.');
    }
  }
}